module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"register_modal::cancel-button":"Отменить все изменения","register_modal::save-button":"Сохранить"}}')
  delete Component.options._Ctor
}
